// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"478":"f0cb42b2","622":"2dc6ce5a","787":"9e5e3356"}[chunkId] + ".chunk.js";
};